import { render, staticRenderFns } from "./DomainPrice.vue?vue&type=template&id=79b031e6&scoped=true&"
import script from "./DomainPrice.vue?vue&type=script&lang=js&"
export * from "./DomainPrice.vue?vue&type=script&lang=js&"
import style0 from "./DomainPrice.vue?vue&type=style&index=0&id=79b031e6&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "79b031e6",
  null
  
)

export default component.exports